// Template212: Osaka - Día 3 Universal Studios Japan (Page9)
// Portada, intro, Super Nintendo World, acceso box, Express Pass, tip entrada.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template212 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const titleOverlayRaw = page?.texts?.[1]?.content;
	const titleOverlay =
		isSmallScreen && page?.data?.headerMobile
			? page.data.headerMobile
			: titleOverlayRaw;
	const intro = page?.texts?.[2]?.content;
	const nintendoTitle = page?.texts?.[3]?.content;
	const nintendoBody = page?.texts?.[4]?.content;
	const accesoTitle = page?.texts?.[5]?.content;
	const accesoList = page?.texts?.[6]?.content;
	const expressTitle = page?.texts?.[7]?.content;
	const expressBody = page?.texts?.[8]?.content;
	const tipEntrada = page?.texts?.[9]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const portadaSticker = getCanvasImageUrl("portada-sticker");
	const nintendoImage = getImageSrc("nintendo");
	const atraccionImage = getImageSrc("atraccion");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];

	const actualHeaderColor = headerBackgroundColor || "#1F4E3D";

	const contentColor = textColor || "#444";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
		color: contentColor,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *:not([data-template-header])": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
					color: "inherit",
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{isSmallScreen && page?.data?.headerMobile
					? page.data.headerMobile
					: headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box data-block-id="image-0" sx={{ position: "relative" }}>
				{portadaImage && (
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
				)}
				{titleOverlay && (
					<Box
						component="h1"
						sx={{
							fontSize: 28,
							textAlign: "center",
							position: "absolute",
							bottom: 0,
							margin: 1.25,
							left: 20,
							color: "#fff",
							textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
						}}
					>
						{titleOverlay}
					</Box>
				)}
				{portadaSticker && (
					<Box
						component="img"
						src={portadaSticker}
						alt=""
						sx={{ width: 100, position: "absolute", bottom: 55, left: 21 }}
					/>
				)}
			</Box>

			<Box data-block-id="text-1" sx={{ padding: "10px 12px" }}>
				{intro && (
					<Box sx={{ fontSize: 13, color: "#333", margin: 0, padding: 0 }}>
						{intro}
					</Box>
				)}

				<Box
					data-block-id="text-2"
					sx={{
						flex: 1,
						display: "flex",
						flexDirection: "column",
						gap: 2,
						position: "relative",
						marginTop: 1.25,
					}}
				>
					<Box
						sx={{
							display: "flex",
							gap: 2,
							alignItems: "flex-start",
							position: "relative",
						}}
					>
						{nintendoImage && (
							<Box
								component="img"
								src={nintendoImage}
								alt=""
								sx={{ width: "40%", borderRadius: "12px", objectFit: "cover" }}
							/>
						)}
						{sabiasQue.length > 0 && (
							<>
								<Box sx={{ position: "absolute", top: 0, left: "33%" }}>
									<SabiasQue
										icono={sabiasQue[0]?.icono ?? "🍄"}
										texto={sabiasQue[0]?.texto ?? ""}
									/>
								</Box>
								{sabiasQue[1] && (
									<Box sx={{ position: "absolute", top: 40, left: "33%" }}>
										<SabiasQue
											icono={sabiasQue[1]?.icono ?? "🎭"}
											texto={sabiasQue[1]?.texto ?? ""}
										/>
									</Box>
								)}
							</>
						)}
						<Box sx={{ width: "60%" }}>
							{nintendoTitle && (
								<Box component="h3" sx={estiloH3}>
									{nintendoTitle}
								</Box>
							)}
							{nintendoBody && (
								<Box component="p" sx={estiloP}>
									{nintendoBody}
								</Box>
							)}
						</Box>
					</Box>

					{(accesoTitle || accesoList) && (
						<Box
							data-block-id="text-3"
							sx={{
								backgroundColor: "#d1e6de",
								border: `3px solid ${actualHeaderColor}`,
								borderRadius: "12px",
								padding: "16px 20px",
								fontSize: 12,
								color: "#333",
							}}
						>
							{accesoTitle && (
								<Box
									component="h4"
									sx={{
										margin: 0,
										marginBottom: 1,
										fontSize: 13,
										fontWeight: 700,
										color: contentColor,
										textTransform: "uppercase",
									}}
								>
									{accesoTitle}
								</Box>
							)}
							{accesoList && (
								<Box
									component="ul"
									sx={{
										paddingLeft: 2.5,
										margin: 0,
										lineHeight: 1.5,
										fontSize: 13,
									}}
									dangerouslySetInnerHTML={{ __html: accesoList }}
								/>
							)}
						</Box>
					)}

					<Box data-block-id="text-4" sx={{ position: "relative" }}>
						{expressTitle && (
							<Box component="h3" sx={estiloH3}>
								{expressTitle}
							</Box>
						)}
						{expressBody && (
							<Box
								component="p"
								sx={{ ...estiloP, width: isSmallScreen ? "100%" : "60%" }}
							>
								{expressBody}
							</Box>
						)}
						{atraccionImage && (
							<Box
								component="img"
								src={atraccionImage}
								alt=""
								sx={{
									width: 100,
									position: "absolute",
									bottom: isSmallScreen ? -100 : -20,
									right: 0,
								}}
							/>
						)}
						{tipEntrada && (
							<Box
								sx={{
									position: "absolute",
									bottom: isSmallScreen ? -80 : 40,
									right: isSmallScreen ? 80 : 30,
									backgroundColor: "#fff8db",
									border: "2px solid #f5c400",
									borderRadius: "16px 16px 0px 16px",
									padding: "10px 12px",
									fontSize: 11,
									color: contentColor,
									boxShadow: "2px 2px 4px rgba(0,0,0,0.15)",
									maxWidth: isSmallScreen ? 220 : 160,
								}}
								dangerouslySetInnerHTML={{ __html: tipEntrada }}
							/>
						)}
					</Box>
				</Box>
			</Box>
		</Box>
	);
};

Template212.thumbnail = "/images/template-1.png";
export default Template212;
